export default __webpack_public_path__ + "static/media/1886.a7b993b7.png";